import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Job } from 'src/@core/interfaces/job/job.model';
import { JobService } from 'src/@core/services/job/job.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { scaleIn400ms } from 'src/@core/animations/scale-in.animation';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { EmployerService } from 'src/@core/services/employer/employer.service';
import { JobType } from 'src/@core/interfaces/job/job-type.model';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/@core/services/notification.service';
import { MatDialog } from '@angular/material';
import { CreateQuoteComponent } from '../create-quote/create-quote.component';
import { AppService } from 'src/@core/services/app.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { PDFDocument } from 'pdf-lib';
@Component({
  selector: 'hour4u-admin-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.scss'],
  animations: [fadeInRight400ms, scaleIn400ms]
})
export class ViewQuoteComponent implements OnInit {

  data: Job = new Job();
  employer: Employer;
  jobType: JobType;
  roles = roles;
  entityTypes = entityTypes;
  imageUrl = environment.image_url;
  profile = this.appService.getCurrentAccount();
  quoteDetails: any = null;
  @Input() quoteId?: any = null;
  isDownloading: boolean = false;
  isLoading: boolean = false;
  @ViewChild('content', { static: false }) content: ElementRef;
  @ViewChild('downloadButton', { static: false }) downloadButton: ElementRef;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  @Output() convertedBase64 = new EventEmitter();

  constructor(
    private jobService: JobService,
    private employerService: EmployerService,
    private jobTypeService: JobTypeService,
    private route: ActivatedRoute,
    private router: Router,
    private notify: NotificationService,
    private dialog: MatDialog,
    private appService: AppService
  ) { }

  ngOnInit() {
    console.log("@@@@@@@@@@@@@@@@", this.quoteId)
    this.route.params.subscribe(data => {
      console.log(data)
      if (data.id)
        this.quoteId = data.id;
      this.getQuoteById();
    });
  }

  // get Quote By Id
  getQuoteById() {
    this.isLoading = true;
    this.jobService.getQuotationById(this.quoteId).subscribe((res: any) => {
      console.log(res)
      this.quoteDetails = res;
      this.isLoading = false;
      this.loadData();
    }, (err => {
      this.isLoading = false;
    }))
  }

  /**
   * Get job from server
   */
  loadData() {
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      let params = { 'entityId': this.profile.entity.id };
      this.isLoading = true;
      this.jobService.getJobDetailsById(this.quoteDetails.jobId, params).subscribe((job: any) => {
        this.data = job;
        this.isLoading = false;
        console.log(this.data)
        this.setAgenciesName();
        this.loadJobType();
        // this.setPDF();
      }, (err => {
        this.isLoading = false;
      }))
    }
  }

  setAgenciesName() {
    if (this.data && this.data.assignedEntities && this.data.assignedEntities.length) {
      this.data.assignedEntitiesName = [];
      this.data.assignedEntities.forEach(element => {
        this.data.assignedEntitiesName.push(element.name);
      })
    }
  }

  /**
   * Get emplyer from server to show
   */
  loadEmployers() {
    if (this.data.employerId) {
      this.employerService.getById(this.data.employerId).subscribe(employer => {
        this.employer = employer;
      })
    }
  }

  /**
   * Get emplyer from server to show
   */
  loadJobType() {
    this.jobTypeService.getById(this.data.jobTypeId).subscribe(type => {
      this.jobType = type;
    })
  }

  getTotalQuantity() {
    let quantity = 0;
    if (this.quoteDetails && this.quoteDetails.jobRateCards && this.quoteDetails.jobRateCards.length) {
      this.quoteDetails.jobRateCards.forEach(element => {
        quantity = quantity + element.quantity;
      });
    }
    return quantity;
  }

  getTotalAmount() {
    let amount = 0;
    if (this.quoteDetails && this.quoteDetails.jobRateCards && this.quoteDetails.jobRateCards.length) {
      this.quoteDetails.jobRateCards.forEach(element => {
        amount = amount + (element.rate * element.quantity);
      });
    }
    return amount;
  }

  getFinalTotalAmount() {
    let amount = 0;
    if (this.quoteDetails && this.quoteDetails.jobRateCards && this.quoteDetails.jobRateCards.length) {
      this.quoteDetails.jobRateCards.forEach(element => {
        amount = amount + (element.totalAmount);
      });
    }
    return amount;
  }

  downloadAttachment(attachmentName: string): void {
    // Create an anchor element and trigger a click to download the file
    const link = document.createElement('a');
    link.href = `${this.imageUrl}${attachmentName}`;
    link.target = '_blank';
    link.download = attachmentName;
    link.click();
  }

  // create Work Order
  createWorkOrder() {
    console.log(this.data, this.employer, this.jobType);
    const navigationExtras: NavigationExtras = {
      queryParams: { 'jobId': this.data.id, 'jobTypeId': this.data.jobTypeId, 'employerId': this.data.employerId }
    }
    this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  }

  // approve/reject Project
  approveRejectProject(data, status) {
    console.log(data, status)
    this.jobService.updateProjectStatus(data.assignmentId, status).subscribe(res => {
      this.loadData();
      this.notify.showMessage('Project Status Updated Successfully!', 2000);
    }, ((err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    }))
  }

  // prepare And Send Quote
  prepareAndSendQuote() {
    this.data.action = 'Create';
    const dialogRef = this.dialog.open(CreateQuoteComponent, {
      width: '900px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: this.data,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  // setPDF() {
  //   const pdfStyles = `
  //   @media screen and (max-width: 769px) {
  //       .m-view-header-wrap {
  //           display: grid !important;
  //       }
  //   }

  //   .text-start {
  //       text-align: left;
  //   }

  //   th {
  //       background-color: #efefef;
  //   }

  //   th,
  //   td {
  //       padding: 10px;
  //   }

  //   .b-top {
  //       border-top: 1px solid #efefef;
  //   }

  //   .app-button {
  //       // width: 50% !important;
  //       height: auto !important;
  //       font-size: 14px !important;
  //       line-height: 20px !important;
  //       font-weight: 500;
  //       padding: 12px 20px !important;
  //       border-radius: 12px;
  //       background: var(--primary-60, #D95938);
  //   }

  //   .rej-button {
  //       // width: 50% !important;
  //       height: auto !important;
  //       font-size: 14px !important;
  //       line-height: 20px !important;
  //       font-weight: 500;
  //       padding: 12px 20px !important;
  //   }

  //   .warn-wrap {
  //       border-radius: 12px;
  //       background: var(--Error-30, #FFEBEE);
  //       display: flex;
  //       padding: 16px;
  //       gap: 10px;
  //       margin-bottom: 16px;
  //       margin-top: 8px;

  //       .warn-text {
  //           color: var(--Error-60, #FF4E5B);
  //           font-size: 14px;
  //           font-style: normal;
  //           font-weight: 400;
  //           line-height: 20px;
  //       }
  //   }

  //   ::ng-deep .mat-dialog-content {
  //       scrollbar-width: thin !important;
  //   }

  //   .add-edit-staff-dialog {
  //       ::ng-deep .mat-dialog-content {
  //           scrollbar-width: thin !important;
  //       }
  //   }

  //   @media screen and (max-width: 769px) {
  //       ::ng-deep .add-edit-staff-dialog {
  //           height: calc(100% - 30px) !important;
  //           width: calc(100% - 30px) !important;
  //           max-width: 100% !important;
  //           max-height: 100% !important;
  //       }
  //   }

  //   .signature-img {
  //       width: 100%;
  //       height: 10vh;
  //   }
  //   `;

  //   const element = this.content.nativeElement;
  //   // const button = this.downloadButton.nativeElement;
  //   const originalHeight = element.style.height;
  //   const originalOverflow = element.style.overflow;
  //   // this.isDownloading = true;

  //   // Hide the button
  //   // button.style.display = 'none';

  //   // Temporarily expand the element to show all content
  //   element.style.height = 'auto';
  //   element.style.overflow = 'visible';

  //   // Create a style element and append the CSS styles
  //   const styleElement = document.createElement('style');
  //   styleElement.type = 'text/css';  // Fixed the type to 'text/css'
  //   styleElement.innerHTML = pdfStyles;
  //   document.head.appendChild(styleElement);

  //   // Load Google Material Icons font
  //   const linkElement = document.createElement('link');
  //   linkElement.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
  //   linkElement.rel = 'stylesheet';
  //   document.head.appendChild(linkElement);

  //   // Ensure the font and other resources are fully loaded before generating the PDF
  //   linkElement.onload = () => {
  //     setTimeout(() => {
  //       html2canvas(element).then((canvas) => {
  //         const imgData = canvas.toDataURL('image/png');
  //         const pdf = new jsPDF('p', 'mm', 'a4');
  //         const pdfWidth = pdf.internal.pageSize.getWidth();
  //         const pdfHeight = pdf.internal.pageSize.getHeight();
  //         const imgProps = pdf.getImageProperties(imgData);
  //         const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //         let heightLeft = imgHeight;
  //         let position = 0;

  //         // Add the image to the PDF and handle page breaks if needed
  //         pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
  //         heightLeft -= pdfHeight;

  //         while (heightLeft > 0) {
  //           position = heightLeft - imgHeight;
  //           pdf.addPage();
  //           pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
  //           heightLeft -= pdfHeight;
  //         }

  //         // pdf.save('signed_contract_' + this.quoteDetails.id + '.pdf');

  //         // Restore the original size and visibility
  //         element.style.height = originalHeight;
  //         element.style.overflow = originalOverflow;

  //         // Remove the style element
  //         document.head.removeChild(styleElement);
  //         document.head.removeChild(linkElement);

  //         // Show the button again
  //         // button.style.display = 'flex'; // Ensure it matches the initial display style

  //         // Reset the downloading state
  //         // this.isDownloading = false;

  //         // Inside the setTimeout function after generating the PDF
  //         // const base64String = pdf.output('datauristring');
  //         // console.log('Base64 PDF:', base64String);
  //         // // this.convertedBase64.emit(base64String);

  //         // // Inside your setPDF() function after generating the PDF
  //         // const blob = this.convertPdfToBlob(base64String);
  //         // const file = this.convertBlobToFile(blob, 'signed_contract.pdf');
  //         // console.log('File:', file);

  //         const blob = pdf.output('blob'); // Get the PDF as a Blob

  //         // Convert Blob to File
  //         const file = new File([blob], 'signed_contract.pdf', { type: 'application/pdf' });

  //         // Use the File object as needed
  //         console.log('Compressed File:', file);
  //         this.convertedBase64.emit(file);

  //       }).catch(error => {
  //         console.error('Error generating PDF:', error);
  //         // Show the button again if there's an error
  //         // button.style.display = 'flex'; // Ensure it matches the initial display style
  //         // this.isDownloading = false;
  //       });
  //     }, 2000); // Increased the timeout duration to ensure fonts and images are loaded
  //   };

  //   linkElement.onerror = () => {
  //     console.error('Error loading the Google Material Icons font');
  //     // this.isDownloading = false;
  //   };
  // }

  convertPdfToBlob(pdfBase64: string): Blob {
    // Decode the Base64 string into binary data
    const binaryData = atob(pdfBase64.split(',')[1]);

    // Create an array buffer from the binary data
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob object from the array buffer
    return new Blob([uint8Array], { type: 'application/pdf' });
  }

  convertBlobToFile(blob: Blob, filename: string): File {
    // Create a File object from the Blob
    return new File([blob], filename, { type: 'application/pdf' });
  }

  async downloadSignedDoc() {
    let pdfStyles = `
    .contract-wrapper {
        padding: 24px;
        background: #fff;
        border-radius: var(--radius-xl, 12px);
    }

    .header {
        border-radius: var(--radius-xl, 12px);
        background: var(--Neutral-20, #F6F6F6);
        padding: 12px 16px;
    }

    .sub-header {
        padding: 12px 16px;
    }

    .f-wrap {
        flex-wrap: wrap !important;
    }

    .signature-section {
        width: 50%;
    }

    .inputt-wrap {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
    }

    .signature-img {
        max-width: 60%;
        max-height: 20vh;
    }

    .custom-signature-card {
        border-radius: var(--radius-xl, 12px);
        border: 1px dashed var(--Neutral-60, #1A1A1A);
        background: var(--base-w-white, #FFF);
        box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
        display: inline-flex;
        height: 132px;
        padding: 16px 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .d-flex {
        display: flex;
    }

    .secondary {
        color: #1A1A1A !important;
    }

    .sub-heading-mm {
        font-style: normal !important;
        font-size: 14px !important;
    }

    .sub-heading-sm {
      font-style: normal !important;
        font-size: 14px !important;
    }

    .justify-space-between {
        justify-content: space-between !important;
    }

    .text-center {
        text-align: center;
    }

     .outer-wrap {
        flex: 1;
        overflow: visible !important;
    }

    .inner-wrap {
        flex: 1;
        overflow-y: visible !important;
    }
         .w-70 {
      width : 100% !important;
    }

    .h-82{
    height : auto !important;
    }
    `;
    if (window.innerWidth <= 768) {
      pdfStyles = `
    .contract-wrapper {
        padding: 24px;
        background: #fff;
        border-radius: var(--radius-xl, 12px);
    }

    .header {
        border-radius: var(--radius-xl, 12px);
        background: var(--Neutral-20, #F6F6F6);
        padding: 12px 16px;
    }

    .sub-header {
        padding: 12px 11px;
    }

    .f-wrap {
        flex-wrap: wrap !important;
    }

    .signature-section {
        width: 50%;
    }

    .inputt-wrap {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
    }

    .signature-img {
        max-width: 60%;
        max-height: 20vh;
    }

    .custom-signature-card {
        border-radius: var(--radius-xl, 12px);
        border: 1px dashed var(--Neutral-60, #1A1A1A);
        background: var(--base-w-white, #FFF);
        box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
        display: inline-flex;
        height: 132px;
        padding: 16px 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .d-flex {
        display: flex;
    }

    .secondary {
        color: #1A1A1A !important;
    }

    .sub-heading-mm {
        font-style: normal !important;
        font-size: 12px !important;
    }

    .sub-heading-sm {
      font-style: normal !important;
        font-size: 12px !important;
    }

    .justify-space-between {
        justify-content: space-between !important;
    }

    .text-center {
        text-align: center;
    }

     .outer-wrap {
        flex: 1;
        overflow: visible !important;
    }

    .inner-wrap {
        flex: 1;
        overflow-y: visible !important;
    }

    .m-4 {
        margin: 0px !important;
    }

    .w-70 {
        grid-area: agreement-doc;
        //     display: none;
        width: 100% !important;
        padding: 0px !important;
    }

    .w-30 {
        width: 100% !important;
        grid-area: sign-contract;
        padding: 16px !important;
        background-color: transparent !important;
    }

    .h-82 {
        display: grid !important;
        grid-template-areas:
            "sign-contract"
            "agreement-doc" !important;
        height: auto !important;
    }

    .footer-card {
        bottom: 8% !important;
        margin: 0px !important;
    }
    `;
    }


    const element = this.content.nativeElement;
    element.style.display = 'block';

    const originalHeight = element.style.height;
    const originalOverflow = element.style.overflow;
    this.isDownloading = true;

    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = pdfStyles;
    document.head.appendChild(styleElement);

    // Function to resize inputs if necessary
    const resizeInputs = () => {
      const inputs = element.querySelectorAll('.inputt-wrap');
      inputs.forEach(input => {
        const valueLength = input.value.length;
        const newWidth = valueLength && (valueLength >= 20 && valueLength <= 40) ? (valueLength + 1) * 8 : 150;
        input.style.width = `${newWidth}px`;
        if (window.innerWidth <= 768) {
          input.style.lineHeight = '20px';
        }
        input.style.backgroundColor = 'transparent';
      });
    };

    // Load images function
    const loadImages = (): Promise<void[]> => {
      const images = Array.from(document.querySelectorAll('img.signature-img'));
      const imagePromises = images.map((img: HTMLImageElement) => {
        return new Promise<void>((resolve, reject) => {
          fetch(img.src, {
            method: 'GET',
            mode: 'no-cors'
          })
            .then(response => {
              console.log(response)
              resolve();
            })
            .catch(error => {
              console.error('There has been a problem with your fetch operation:', error);
              reject(new Error('Image failed to load'));
            });
        });
      });
      return Promise.all(imagePromises);
    };

    try {
      // Ensure all images and fonts are loaded
      await Promise.all([loadImages(), resizeInputs()]);
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Use html2canvas to capture the entire content as a single canvas
      const canvas = await html2canvas(element, {
        scale: 2, // Adjust scale if needed
        useCORS: true,
        allowTaint: true, // Allow taint to render images from other domains
      });

      // Calculate dimensions for jsPDF
      const pdfWidth = canvas.width * 0.264583; // Convert px to mm (1px = 0.264583mm)
      const pdfHeight = canvas.height * 0.264583; // Convert px to mm

      // Create jsPDF instance
      const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight], true);

      // Add the captured canvas as an image to jsPDF
      pdf.addImage(canvas, 'JPEG', 0, 0, pdfWidth, pdfHeight);

      // Save or download the PDF
      pdf.save('signed_contract.pdf');

      // Reset styles and flags
      element.style.height = originalHeight;
      element.style.overflow = originalOverflow;
      document.head.removeChild(styleElement);
      this.isDownloading = false;

    } catch (error) {
      console.error('Error generating PDF:', error);
      this.isDownloading = false;
      element.style.height = originalHeight;
      element.style.overflow = originalOverflow;
    }
  }

  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.quoteDetails && this.quoteDetails.jobRateCards && this.quoteDetails.jobRateCards.length) {
        this.quoteDetails.jobRateCards.forEach(element => {
          totalBilling = totalBilling + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.quoteDetails.variableJobRateCards && this.quoteDetails.variableJobRateCards.length) {
        this.quoteDetails.variableJobRateCards.forEach(element => {
          totalBilling = totalBilling + (element.rate * element.quantity);
        });
      }
    }

    return totalBilling;
  }

  // get Total Billing's GST
  getTotalBillingGST() {
    let totalBillingGST = 0;
    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.quoteDetails && this.quoteDetails.jobRateCards && this.quoteDetails.jobRateCards.length) {
        this.quoteDetails.jobRateCards.forEach(element => {
          totalBillingGST = totalBillingGST + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.quoteDetails.variableJobRateCards && this.quoteDetails.variableJobRateCards.length) {
        this.quoteDetails.variableJobRateCards.forEach(element => {
          totalBillingGST = totalBillingGST + (element.rate * element.quantity);
        });
      }
    }
    return totalBillingGST * 0.18;
  }

  // get Total Billing With GST
  getTotalBillingWithGST() {
    let totalBillingWithGST = 0;

    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.quoteDetails && this.quoteDetails.jobRateCards && this.quoteDetails.jobRateCards.length) {
        this.quoteDetails.jobRateCards.forEach(element => {
          totalBillingWithGST = totalBillingWithGST + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.quoteDetails.variableJobRateCards && this.quoteDetails.variableJobRateCards.length) {
        this.quoteDetails.variableJobRateCards.forEach(element => {
          totalBillingWithGST = totalBillingWithGST + (element.rate * element.quantity);
        });
      }
    }
    return totalBillingWithGST * 1.18;
  }

  // review page toggle expand
  toggleExpandValue(index: number, forWhat?: string) {
    if (forWhat == 'FIXED') {
      if (this.data.rateCards && this.data.rateCards.length) {
        this.data.rateCards.forEach((rateCard: any, idx) => {
          if (index == idx) {
            rateCard.expanded = !rateCard.expanded;
          }
        });
      }
    }

    if (forWhat == 'VARIABLE') {
      if (this.data.variableJobRateCards && this.data.variableJobRateCards.length) {
        this.data.variableJobRateCards.forEach((rateCard: any, idx) => {
          if (index == idx) {
            rateCard.expanded = !rateCard.expanded;
          }
        });
      }
    }
  }

  preventToggle(event: Event) {
    event.stopPropagation();
  }

  // accept Reject Quote
  acceptRejectQuote(quoteDetails, status) {
    this.quoteDetails.quoteStatusChangeCalled = false;
    if (status == 'ACCEPTED' && quoteDetails && quoteDetails.signatureRequired) {
      this.data.quoteStatusChangeCalled = true;
    } else {
      this.jobService.updateQuoteStatus(quoteDetails.id, status).subscribe(res => {
        this.getQuoteById();
        this.notify.showMessage('Quotation Status Updated Successfully!', 2000);
      }, ((err: any) => {
        this.notify.showMessage(err.error.message, 2000);
      }))
    }
  }

  backToProject() {
    this.router.navigateByUrl('/job/view/' + this.quoteDetails.jobId)
  }
}